import {
  URL_CREATE_JOB,
  URL_EDIT_JOB,
  URL_REFRESH_JOB,
} from '@seek/adv-constants';

const ROUTE_BASE = '/job/managejob/express';

// Top level app routes
export const ROUTE_CREATE = URL_CREATE_JOB;
export const ROUTE_EDIT = URL_EDIT_JOB;
export const ROUTE_REFRESH = URL_REFRESH_JOB;

// Create flow routes
export const ROUTE_CLASSIFY = `${ROUTE_CREATE}/classify`;
export const ROUTE_MANAGE = `${ROUTE_CREATE}/manage`;
export const ROUTE_PAY_AND_POST = `${ROUTE_CREATE}/pay-and-post`;
export const ROUTE_PAY_AND_POST_V2 = `${ROUTE_CREATE}/pay-and-post-v2`;
export const ROUTE_SELECT_AD_TYPE = `${ROUTE_CREATE}/select-ad-type`;
export const ROUTE_SUCCESS = `${ROUTE_CREATE}/success`;
export const ROUTE_WRITE = `${ROUTE_CREATE}/write`;
export const ROUTE_CONCIERGE = `${ROUTE_CREATE}/concierge`;
export const ROUTE_GUARANTEED_HIRE = `${ROUTE_CREATE}/guaranteed-hire`;
export const ROUTE_PREMIUM_PLUS = `${ROUTE_CREATE}/premium-plus`;

// Edit flow routes
export const ROUTE_EDIT_PAY_AND_POST = `${ROUTE_EDIT}/pay-and-post`;
export const ROUTE_EDIT_SUCCESS = `${ROUTE_EDIT}/success`;

// Refresh flow routes
export const ROUTE_REFRESH_SUCCESS = `${ROUTE_REFRESH}/success`;
export const ROUTE_REFRESH_ERROR = `${ROUTE_REFRESH}/error`;

// Multi location routes
export const ROUTE_MULTI_LOCATION = `${ROUTE_BASE}/multi-location`;

// Misc routes
export const ROUTE_TEST_PAGE = `${ROUTE_BASE}/test-page`;
